import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const SprocketIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Sprocket",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M23.2 11.21V7.88c.88-.42 1.48-1.29 1.48-2.31V5.5c0-1.41-1.15-2.56-2.56-2.56h-.07c-1.41 0-2.56 1.15-2.56 2.56v.07c0 1.02.6 1.9 1.46 2.31h.02v3.34c-1.33.2-2.5.74-3.47 1.53h.01L8.37 5.63c.06-.22.1-.47.11-.73 0-1.6-1.29-2.89-2.89-2.89S2.7 3.3 2.7 4.9a2.89 2.89 0 0 0 2.88 2.89c.53 0 1.02-.15 1.44-.4h-.01l8.99 7c-.76 1.13-1.21 2.53-1.21 4.03s.5 3.03 1.35 4.22l-.02-.02-2.78 2.73c-.18-.05-.38-.08-.59-.08-1.31 0-2.37 1.06-2.37 2.37s1.06 2.37 2.37 2.37 2.37-1.06 2.37-2.37v-.03c0-.24-.05-.47-.12-.69v.02l2.67-2.66c1.2.9 2.72 1.45 4.36 1.45 4.03 0 7.3-3.27 7.3-7.3a7.29 7.29 0 0 0-6.06-7.19h-.04Zm-1.12 10.95c-2.07 0-3.75-1.68-3.75-3.75s1.68-3.75 3.75-3.75 3.75 1.68 3.75 3.75c0 2.08-1.68 3.75-3.74 3.75Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M23.38 7.88v3.33c3.1.47 5.57 2.75 6.21 5.74.63 2.98-.7 6.04-3.36 7.66-2.65 1.62-6.07 1.47-8.56-.38l-2.79 2.71c.07.22.11.45.11.68 0 .96-.6 1.83-1.51 2.2s-1.97.16-2.66-.52c-.7-.68-.91-1.7-.53-2.59s1.27-1.47 2.26-1.47c.24 0 .47.04.7.11l2.82-2.74a7.13 7.13 0 0 1-.12-8.22l-9.25-7c-.45.25-.95.39-1.47.39-1.64 0-2.97-1.3-2.97-2.9S3.6 1.99 5.24 1.99s2.97 1.3 2.97 2.9c0 .24-.04.49-.11.72l9.41 7.12a7.57 7.57 0 0 1 3.56-1.52V7.88c-.92-.42-1.52-1.32-1.52-2.31v-.08c0-1.41 1.18-2.56 2.64-2.56h.08c1.45 0 2.63 1.15 2.64 2.56v.08c0 .99-.6 1.89-1.52 2.31Zm-5.02 10.55c0 2.07 1.73 3.75 3.85 3.75s3.85-1.68 3.85-3.75-1.73-3.75-3.85-3.75-3.85 1.68-3.85 3.75"
      })
    })
  }));
};